export type SyntaxHighlightThemeId =
  | "adaptive"
  | "vscDarkPlus"
  | "oneDark"
  | "oneLight"
  | "nightOwl"
  | "nord"
  | "dracula"
  | "atomDark"
  | "okaidia"
  | "materialDark"
  | "materialLight"
  | "darcula"
  | "duotoneDark"
  | "duotoneLight"
  | "gruvboxDark"
  | "gruvboxLight"
  | "solarizedLight"
  | "tomorrow"
  | "vs";

export const SYNTAX_HIGHLIGHT_THEME_OPTIONS: Array<{
  id: SyntaxHighlightThemeId;
  label: string;
}> = [
  { id: "adaptive", label: "Adaptive (Theme Palette)" },
  { id: "vscDarkPlus", label: "VS Code Dark+" },
  { id: "oneDark", label: "One Dark" },
  { id: "oneLight", label: "One Light" },
  { id: "nightOwl", label: "Night Owl" },
  { id: "nord", label: "Nord" },
  { id: "dracula", label: "Dracula" },
  { id: "atomDark", label: "Atom Dark" },
  { id: "okaidia", label: "Okaidia" },
  { id: "materialDark", label: "Material Dark" },
  { id: "materialLight", label: "Material Light" },
  { id: "darcula", label: "Darcula" },
  { id: "duotoneDark", label: "Duotone Dark" },
  { id: "duotoneLight", label: "Duotone Light" },
  { id: "gruvboxDark", label: "Gruvbox Dark" },
  { id: "gruvboxLight", label: "Gruvbox Light" },
  { id: "solarizedLight", label: "Solarized Light" },
  { id: "tomorrow", label: "Tomorrow" },
  { id: "vs", label: "Visual Studio" },
];

export const DEFAULT_SYNTAX_HIGHLIGHT_THEME_ID: SyntaxHighlightThemeId =
  "adaptive";

export function isSyntaxHighlightThemeId(
  value: unknown,
): value is SyntaxHighlightThemeId {
  return SYNTAX_HIGHLIGHT_THEME_OPTIONS.some((option) => option.id === value);
}

export function normalizeSyntaxHighlightThemeId(
  value: unknown,
): SyntaxHighlightThemeId {
  if (isSyntaxHighlightThemeId(value)) {
    return value;
  }

  return DEFAULT_SYNTAX_HIGHLIGHT_THEME_ID;
}
